import { apiRequest } from './apiClient';

const SOFTPHONE_CONFIG_ENDPOINT = '/api/softphone/config';

/**
 * Netgsm/Netsantral WebRTC softphone yapılandırmasını backend'den alır.
 * SIP şifresi yalnızca bu endpoint üzerinden, oturum açmış yetkili kullanıcıya döner.
 */
export const fetchSoftphoneConfig = async () => {
  return apiRequest(SOFTPHONE_CONFIG_ENDPOINT, { method: 'GET', skipCsrf: true });
};
